"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZWell = void 0;
const React = __importStar(require("react"));
const useLocalizedProps_1 = require("../../languages/useLocalizedProps");
const styled_components_1 = __importDefault(require("styled-components"));
exports.ZWell = (props) => {
    const { header } = useLocalizedProps_1.useLocalizedProps(props), StyledFieldset = styled_components_1.default.fieldset `
         padding: 3px 3px 13px 3px;
         margin: 15px 10px;
         background-color: ${p => p.theme["top-toolbar-inset-background-color"]};
         border: 1px solid ${p => p.theme["top-toolbar-inset-border-color"]};
         border-top: 1px solid
            ${p => p.theme["top-toolbar-inset-top-border-color"]};
         border-bottom: 1px solid
            ${p => p.theme["top-toolbar-inset-bottom-border-color"]};
         position: relative;
         display: inline-block;
      `, StyledLegend = styled_components_1.default.legend `
         margin: 10px;
         padding: 5px 10px;
         width: auto;
         font-weight: bold;
         font-size: 12px;
         color: ${p => p.theme["pane-header-color"]};
         text-transform: uppercase;
         background-color: ${p => p.theme["top-toolbar-inset-background-color"]};
         border: 1px solid ${p => p.theme["top-toolbar-inset-border-color"]};
         border-top: 1px solid
            ${p => p.theme["top-toolbar-inset-top-border-color"]};
         border-bottom: 1px solid
            ${p => p.theme["top-toolbar-inset-bottom-border-color"]};
         min-width: 10px;
      `;
    return (React.createElement(StyledFieldset, null,
        React.createElement(StyledLegend, null, header),
        React.createElement("div", null, props.children)));
};
//# sourceMappingURL=ZWell.js.map